export enum LocationKey {
  // The light world locations
  KingsTomb,
  LightWorldSwamp,
  LinksHouse,
  SpiralCave,
  MimicCave,
  Tavern,
  ChickenHouse,
  AginahsCave,
  SahasrahlasHut,
  KakarikoWell,
  BlindsHut,
  ParadoxCave,
  BonkRocks,
  MiniMoldormCave,
  IceRodCave,
  BottleVendor,
  SahasrahlasReward,
  SickKid,
  BridgeHideout,
  EtherTablet,
  BombosTablet,
  KingZora,
  LostOldMan,
  PotionShop,
  ForestHideout,
  LumberjackTree,
  SpectacleRockCave,
  MirrorCave,
  GraveyardCliffCave,
  CheckerboardCave,
  Library,
  Mushroom,
  SpectacleRock,
  FloatingIsland,
  RaceMinigame,
  DesertWestLedge,
  LakeHyliaIsland,
  ZoraLedge,
  BuriedItem,
  SewerEscapeSideRoom,
  CastleSecretEntrance,
  CastleDungeon,
  Sanctuary,
  MadBatter,
  DwarfEscort,
  MasterSwordPedestal,
  SewerEscapeDarkRoom,
  WaterfallOfWishing,
  // The dark world locations
  BombableHut,
  CShapedHouse,
  MireHut,
  SuperBunnyCave,
  SpikeCave,
  HypeCave,
  HookshotCaveBottom,
  HookshotCaveTop,
  TreasureChestMinigame,
  StumpKid,
  PurpleChest,
  Catfish,
  HammerPegCave,
  BumperCave,
  Pyramid,
  DiggingGame,
  PyramidFairy
}
